import React, { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';

import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const ProfileStrength = ({ id }) => {
	const [, setIsLoading] = useState(false);
	const [certificationTagList, setCertificationTagList] = useState([]);
	const [topThreeSkillTagList, setTopThreeSkillTagList] = useState([]);
	const [otherSkillTagList, setOtherSkillTagList] = useState([]);
	const [stakeHolderCustomerTagList, setStakeHolderCustomerTagList] = useState([]);
	const [stakeHolderSupplierTagList, setStakeHolderSupplierTagList] = useState([]);
	const [stakeHolderThirdPartyTagList, setStakeHolderThirdPartyTagList] = useState([]);

	useEffect(() => {
		if (id) getUserProfileStrength();
	}, [id]);

	const getUserProfileStrength = () => {
		setIsLoading(true);

		ApiClient.GET('userStrengthInfo', id)
			.then(({ data }) => {
				setIsLoading(false);
				setCertificationTagList(data.certificationTagList);
				setTopThreeSkillTagList(data.topThreeSkillTagList);
				setOtherSkillTagList(data.otherSkillTagList);
				setStakeHolderCustomerTagList(data.stakeHolderCustomerTagList);
				setStakeHolderSupplierTagList(data.stakeHolderSupplierTagList);
				setStakeHolderThirdPartyTagList(data.stakeHolderThirdPartyTagList);
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	const getComponentOptionsFromTagResponse = (tagResponseList) => {
		return tagResponseList.map((item) => {
			return {
				id: item.id,
				text: item.text,
				value: item.text,
				label: item.text
			};
		});
	};

	const onTagChange = (selected, callable) => {
		let tags = selected.map((item) => {
			if (item.__isNew__) {
				return {
					text: item.label
				};
			} else {
				return {
					text: item.label,
					id: item.id
				};
			}
		});
		callable(tags);
	};

	const onSubmit = (e) => {
		e.preventDefault();
		setIsLoading(true);
		let requestBody = {
			userId: id,
			certificationTagList,
			topThreeSkillTagList,
			otherSkillTagList,
			stakeHolderCustomerTagList,
			stakeHolderSupplierTagList,
			stakeHolderThirdPartyTagList,
			isOnlyTagUpdate: true
		};

		ApiClient.POST('userUpdateTag', requestBody)
			.then(() => {
				toastSuccess('Successfully updated information');
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	return (
		<div id="soft_tech_skill" className="skill-from">
			<div className="form-container">
				<div className="container px-0">
					<div className="row form-row">
						<div className="col-md-12">
							<h2 className="semibold-16 form-title">Certification</h2>
						</div>
						<div className="col-md-12">
							<div className="form-group no-shadow-react-select mb-0">
								<CreatableSelect
									value={getComponentOptionsFromTagResponse(certificationTagList)}
									isMulti
									onChange={(selected) => onTagChange(selected, setCertificationTagList)}
								/>
							</div>
						</div>
					</div>

					<div className="row form-row">
						<div className="col-md-12">
							<h2 className="semibold-16 form-title">Special Skills</h2>
						</div>
						<div className="col-md-12">
							<div className="form-group no-shadow-react-select">
								<label htmlFor="tskills">Top three sills</label>
								<CreatableSelect
									value={getComponentOptionsFromTagResponse(topThreeSkillTagList)}
									isMulti
									onChange={(selected) => onTagChange(selected, setTopThreeSkillTagList)}
								/>
							</div>
						</div>

						<div className="col-md-12">
							<div className="form-group no-shadow-react-select mb-0">
								<label htmlFor="oskills">Other skills</label>
								<CreatableSelect
									value={getComponentOptionsFromTagResponse(otherSkillTagList)}
									isMulti
									onChange={(selected) => onTagChange(selected, setOtherSkillTagList)}
								/>
							</div>
						</div>
					</div>

					<div className="row form-row">
						<div className="col-md-12">
							<h2 className="semibold-16 form-title">Stake Holders</h2>
						</div>
						<div className="col-md-12">
							<div className="form-group no-shadow-react-select">
								<label htmlFor="cbrands">Cusotmer / Brands</label>
								<CreatableSelect
									value={getComponentOptionsFromTagResponse(stakeHolderCustomerTagList)}
									isMulti
									onChange={(selected) =>
										onTagChange(selected, setStakeHolderCustomerTagList)
									}
								/>
							</div>
						</div>

						<div className="col-md-12">
							<div className="form-group no-shadow-react-select">
								<label htmlFor="svendors">Supplier / Vendors</label>
								<CreatableSelect
									value={getComponentOptionsFromTagResponse(stakeHolderSupplierTagList)}
									isMulti
									onChange={(selected) =>
										onTagChange(selected, setStakeHolderSupplierTagList)
									}
								/>
							</div>
						</div>

						<div className="col-md-12">
							<div className="form-group no-shadow-react-select mb-0">
								<label htmlFor="tparty">Other Thired Party Stake Holders</label>
								<CreatableSelect
									value={getComponentOptionsFromTagResponse(stakeHolderThirdPartyTagList)}
									isMulti
									onChange={(selected) =>
										onTagChange(selected, setStakeHolderThirdPartyTagList)
									}
								/>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-md-12 text-right">
							<button className="button" onClick={onSubmit}>
								Save Changes
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProfileStrength;
